export default 'https://tme.understood.org/assets/narnia_door.385f519b.glb'